"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconShop = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "Shop" }, props),
        react_1.default.createElement("title", null, "Shop"),
        react_1.default.createElement("path", { d: "M25.714 34.64l-.835-5.712H8.57V11.787h31.275l3.108 22.853h-17.24z", fill: "#007562" }),
        react_1.default.createElement("path", { d: "M44.85 108.921c7.414 0 13.425-6.01 13.425-13.425 0-7.414-6.01-13.425-13.425-13.425-7.415 0-13.425 6.01-13.425 13.425 0 7.415 6.01 13.425 13.425 13.425zM92.282 108.921c7.415 0 13.425-6.01 13.425-13.425 0-7.414-6.01-13.425-13.425-13.425-7.414 0-13.425 6.01-13.425 13.425 0 7.415 6.01 13.425 13.425 13.425z", fill: "#000" }),
        react_1.default.createElement("path", { d: "M105.664 80.357H31.479l-5.765-45.718h85.715l-5.765 45.718z", fill: "#FF6E00" }),
        react_1.default.createElement("path", { d: "M68.829 80.357h-37.35l-5.83-45.718h43.362l-.182 45.718z", fill: "#D44513" })));
};
exports.default = BrandIconShop;
